module.exports = __webpack_public_path__ + "img/9c5c1e1.jpg";